import {
  CalendarDays,
  Clock3,
  ClipboardCheck,
  Star,
  GraduationCap,
  PartyPopper,
} from "lucide-react";

const icons = [
  <ClipboardCheck size={15} />,
  <Star size={15} />,
  <GraduationCap size={15} />,
  <PartyPopper size={15} />,
];

const badgeStyles = [
  "bg-red-100 text-red-500",
  "bg-sky-100 text-sky-500",
  "bg-yellow-100 text-yellow-600",
  "bg-lime-100 text-lime-600",
];

const CampusActivities = ({ data = [], title = "Campus Activities" }) => {
  const activities = data.map((item, index) => ({
    id: index,
    title: item.events,
    date: (item.date),
    time: (item.time),
    badge: index < 2 ? "All Campuses" : index === 2 ? "Event" : "Celebration",
    icon: icons[index % icons.length],
    badgeColor: badgeStyles[index % badgeStyles.length],
  }));

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3.5">
        <h2 className="text-2xl font-bold text-indigo-950">{title}</h2>

        <button className="text-xs font-medium text-sky-500 transition hover:text-sky-600">
          View Full Events
        </button>
      </div>

      <div className="overflow-x-auto px-2 py-1">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-slate-100 text-left">
              <th className="px-1 py-0.5 text-xs font-semibold uppercase tracking-wide text-slate-500">Events</th>

              <th className="px-1 py-0.5">
                <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
                  <div className="flex h-5 w-5 items-center justify-center rounded-full bg-fuchsia-100 text-fuchsia-700">
                    <CalendarDays size={11} />
                  </div>
                  Date
                </div>
              </th>

              <th className="px-1 py-0.5">
                <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
                  <div className="flex h-5 w-5 items-center justify-center rounded-full bg-pink-100 text-pink-500">
                    <Clock3 size={11} />
                  </div>
                  Time
                </div>
              </th>

              <th className="px-1 py-0.5" />
            </tr>
          </thead>

          <tbody>
            {activities.map((item) => (
              <tr
                key={item.id}
                className="border-b border-slate-50 transition hover:bg-slate-50"
              >
                <td className="px-1 py-0.5">
                  <div className="flex items-center gap-2.5">
                    <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-fuchsia-700 text-white">
                      {item.icon}
                    </div>

                    <span className="text-sm font-medium text-slate-700">
                      {item.title}
                    </span>
                  </div>
                </td>

                <td className="px-1 py-0.5 text-sm text-slate-500">{item.date}</td>
                <td className="px-1 py-0.5 text-sm text-slate-500">{String(item.time) || "N/A"}</td>
{/*
                <td className="px-1 py-0.5 text-right">
                  <span className={`rounded-full px-5 py-2 text-sm font-medium ${item.badgeColor}`}>
                    {item.badge}
                  </span>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampusActivities;
